import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuthLazy } from "@/lib/attach-supabase-auth";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Encabezados de seguridad para todas las respuestas. La CSP arranca en modo
// Report-Only: se revisan las violaciones antes de pasarla a obligatoria.
const CSP = [
  "default-src 'self'",
  "script-src 'self' 'unsafe-inline' https://js.stripe.com https://*.js.stripe.com https://www.googletagmanager.com https://tpwdg.com https://widgets.bokun.io",
  "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com",
  "font-src 'self' data: https://fonts.gstatic.com",
  "img-src 'self' data: blob: https:",
  "media-src 'self' blob: https:",
  "connect-src 'self' https://*.supabase.co wss://*.supabase.co https://api.stripe.com https://m.stripe.network https://*.google-analytics.com https://www.googletagmanager.com",
  "frame-src https://js.stripe.com https://*.js.stripe.com https://hooks.stripe.com https://checkout.stripe.com https://widgets.bokun.io https://tpwdg.com",
  "frame-ancestors 'self' https://*.lovable.app https://lovable.dev https://*.lovable.dev",
  "form-action 'self' https://checkout.stripe.com",
  "base-uri 'self'",
  "object-src 'none'",
  "report-uri /api/public/csp-report",
].join("; ");

const securityHeadersMiddleware = createMiddleware().server(async ({ next }) => {
  const result: any = await next();
  const res: Response | undefined = result?.response ?? (result instanceof Response ? result : undefined);
  try {
    const h = res?.headers;
    if (h) {
      h.set("Strict-Transport-Security", "max-age=31536000; includeSubDomains");
      h.set("X-Content-Type-Options", "nosniff");
      if (!h.has("Referrer-Policy")) h.set("Referrer-Policy", "strict-origin-when-cross-origin");
      h.set("Permissions-Policy", "camera=(), microphone=(self), geolocation=(self), payment=(self \"https://js.stripe.com\"), usb=(), interest-cohort=()");
      h.set("Cross-Origin-Opener-Policy", "same-origin-allow-popups");
      h.set("Content-Security-Policy-Report-Only", CSP);
    }
  } catch {
    /* headers inmutables en algunas respuestas: se ignoran */
  }
  return result;
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuthLazy],
  requestMiddleware: [securityHeadersMiddleware, errorMiddleware],
}));
